import { Env } from '@region-lib/env';
const { CDN_HOST } = Env;

export const getReactCdn = (env = 'production') => {
  const SCRIPT_ENV_MAP = {
    local: 'https://unpkg.com/react@17/umd/react.development.js',
    test: 'https://unpkg.com/react@17/umd/react.development.js',
    testnet: '/contentstack/js/react-17.0.2.production.min.js',
    production: '/contentstack/js/react-17.0.2.production.min.js',
  };
  return SCRIPT_ENV_MAP[env] || SCRIPT_ENV_MAP.production;
};

export const getReactDomCdn = (env = 'production') => {
  const SCRIPT_ENV_MAP = {
    local: 'https://unpkg.com/react-dom@17/umd/react-dom.development.js',
    test: 'https://unpkg.com/react-dom@17/umd/react-dom.development.js',
    testnet: '/contentstack/js/react-dom-17.0.2.production.min.js',
    production: '/contentstack/js/react-dom-17.0.2.production.min.js',
  };
  return SCRIPT_ENV_MAP[env] || SCRIPT_ENV_MAP.production;
};

export const getRegionFrameCdn = (env = 'production') => {
  const SCRIPT_ENV_MAP = {
    local: '/region-frame/region-frame.js',
    dev: '/region-frame/region-frame.js',
    test: '/region-frame/region-frame.js',
    testnet: `/region-frame/region-frame.js`,
    production: `/region-frame/region-frame.js`,
  };
  return SCRIPT_ENV_MAP[env] || SCRIPT_ENV_MAP.production;
};

export { CDN_HOST };
